webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return moveToFreePlace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cloneItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cloneLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return stringToRGBA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return copyTextToClipboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var areaAt = function areaAt(layout, position) {
  for (var i = 0; i < layout.length; i++) {
    if (layout[i].x < position.x + position.w && layout[i].x + layout[i].w > position.x && layout[i].y < position.y + position.h && layout[i].y + layout[i].h > position.y) {
      return layout[i];
    }
  }
  return false;
};

var moveToFreePlace = function moveToFreePlace(layout, item, maxX, maxY) {
  var newItem = cloneItem(item);
  if (newItem.x < 0 || newItem.x > maxX) {
    newItem.x = 0;
  }
  if (newItem.y < 0 || newItem.y > maxY) {
    newItem.y = 0;
  }
  var startX = newItem.x;
  var startY = newItem.y;

  while (areaAt(layout, newItem)) {
    newItem.y = newItem.y + 1;
    if (newItem.y > maxY) {
      newItem.y = 0;
    }
    if (newItem.y === startY) {
      newItem.x = newItem.x + 1;
      if (newItem.x > maxX) {
        newItem.x = 0;
      }
    }
    if (newItem.y === startY && newItem.x === startX) {
      newItem.y = -1;
      newItem.x = -1;
      return newItem;
    }
  }
  return newItem;
};

var cloneItem = function cloneItem(item) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
};

var cloneLayout = function cloneLayout(layout) {
  return layout.map(function (item) {
    return cloneItem(item);
  });
};

var reverseString = function reverseString(string) {
  return string.split('').reverse().join('');
};

var stringToRGBA = function stringToRGBA(string) {
  var hex = ('000000' + (parseInt(reverseString(string), 36) & 0xffffff).toString(16).toUpperCase()).slice(-6);
  return 'rgba(' + parseInt(hex.slice(0, 2), 16) + ',' + parseInt(hex.slice(2, 4), 16) + ',' + parseInt(hex.slice(4, 6), 16) + ',0.5)';
};

/*!
 * function copyTextToClipboard(text) from  https://stackoverflow.com/a/30810322
 */
var copyTextToClipboard = function copyTextToClipboard(text) {
  var textArea = document.createElement('textarea');

  //
  // *** This styling is an extra step which is likely not required. ***
  //
  // Why is it here? To ensure:
  // 1. the element is able to have focus and selection.
  // 2. if element was to flash render it has minimal visual impact.
  // 3. less flakyness with selection and copying which **might** occur if
  //    the textarea element is not visible.
  //
  // The likelihood is the element won't even render, not even a flash,
  // so some of these are just precautions. However in IE the element
  // is visible whilst the popup box asking the user for permission for
  // the web page to copy to the clipboard.
  //

  // Place in top-left corner of screen regardless of scroll position.
  textArea.style.position = 'fixed';
  textArea.style.top = 0;
  textArea.style.left = 0;

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  textArea.style.width = '2em';
  textArea.style.height = '2em';

  // We don't need padding, reducing the size if it does flash render.
  textArea.style.padding = 0;

  // Clean up any borders.
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';

  // Avoid flash of white box if rendered for any reason.
  textArea.style.background = 'transparent';

  textArea.value = text;

  document.body.appendChild(textArea);

  textArea.select();

  try {
    document.execCommand('copy');
  } catch (err) {}

  document.body.removeChild(textArea);
};

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(60)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(73),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NotFound__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_NotFound__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__components_About___default.a
  }, { path: '*', component: __WEBPACK_IMPORTED_MODULE_4__components_NotFound___default.a }]
}));

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(22);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// root state object.
// each Vuex instance is just a single state tree.
var state = {
  areas: [{ x: 0, y: 0, w: 2, h: 1, label: 'header', id: 0 }, { x: 0, y: 1, w: 1, h: 1, label: 'area2', id: 1 }, { x: 1, y: 2, w: 1, h: 1, label: 'area3', id: 2 }, { x: 2, y: 0, w: 1, h: 3, label: 'sidebar', id: 3 }],
  dragAreas: null,
  columns: [{
    size: 3,
    units: 'fr'
  }, {
    size: 4,
    units: 'fr'
  }, {
    size: 2,
    units: 'fr'
  }],
  rows: [{
    size: 10,
    units: 'rem'
  }, {
    size: 15,
    units: 'rem'
  }, {
    size: 20,
    units: 'rem'
  }],
  colGap: {
    size: 0.5,
    units: 'rem'
  },
  rowGap: {
    size: 0.5,
    units: 'rem'
  },
  justify: {
    value: ''
  },
  align: {
    value: ''
  }

  // A Vuex instance is created by combining the state, mutations, actions,
  // and getters.
};/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__
}));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(63)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(76),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(17);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "action", function() { return action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAreas", function() { return setAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDragAreas", function() { return setDragAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addDragArea", function() { return addDragArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addArea", function() { return addArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeArea", function() { return removeArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addRow", function() { return addRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeRow", function() { return removeRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addColumn", function() { return addColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeColumn", function() { return removeColumn; });
// actions are functions that causes side effects and can involve
// asynchronous operations.

var action = function action(_ref, payload) {
  var commit = _ref.commit,
      state = _ref.state;

  if (state.val) {
    commit('mutation', payload);
  }
};

var setAreas = function setAreas(_ref2, payload) {
  var commit = _ref2.commit,
      state = _ref2.state;

  commit('setAreas', payload);
};

var setDragAreas = function setDragAreas(_ref3, payload) {
  var commit = _ref3.commit,
      state = _ref3.state;

  commit('setDragAreas', payload);
};

var addDragArea = function addDragArea(_ref4, payload) {
  var commit = _ref4.commit,
      state = _ref4.state;

  commit('addDragArea', payload);
};

var addArea = function addArea(_ref5, payload) {
  var commit = _ref5.commit,
      state = _ref5.state;

  commit('addArea', payload);
};

var removeArea = function removeArea(_ref6, payload) {
  var commit = _ref6.commit,
      state = _ref6.state;

  commit('removeArea', payload);
};

var addRow = function addRow(_ref7) {
  var commit = _ref7.commit,
      state = _ref7.state;

  commit('addRow');
};

var removeRow = function removeRow(_ref8, payload) {
  var commit = _ref8.commit,
      state = _ref8.state;

  commit('removeRow', payload);
};

var addColumn = function addColumn(_ref9) {
  var commit = _ref9.commit,
      state = _ref9.state;

  commit('addColumn');
};

var removeColumn = function removeColumn(_ref10, payload) {
  var commit = _ref10.commit,
      state = _ref10.state;

  commit('removeColumn', payload);
};

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areas", function() { return areas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dragAreas", function() { return dragAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rows", function() { return rows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columns", function() { return columns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colGap", function() { return colGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rowGap", function() { return rowGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "justify", function() { return justify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "align", function() { return align; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridSize", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "overflowAreas", function() { return overflowAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validAreas", function() { return validAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridTemplateAreas", function() { return gridTemplateAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridStyle", function() { return gridStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "itemStyle", function() { return itemStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
// getters are functions


var areas = function areas(state) {
  return state.areas;
};
var dragAreas = function dragAreas(state) {
  return state.dragAreas;
};
var rows = function rows(state) {
  return state.rows;
};
var columns = function columns(state) {
  return state.columns;
};
var colGap = function colGap(state) {
  return state.colGap;
};
var rowGap = function rowGap(state) {
  return state.rowGap;
};
var justify = function justify(state) {
  return state.justify;
};
var align = function align(state) {
  return state.align;
};

var gridSize = function gridSize(state) {
  return { w: state.columns.length, h: state.rows.length };
};

var overflowAreas = function overflowAreas(state) {
  return state.areas.filter(function (area) {
    return area.x < 0 || area.y < 0 || area.x >= state.columns.length || area.y >= state.rows.length;
  });
};

var validAreas = function validAreas(state) {
  return state.areas.filter(function (area) {
    return !(area.x < 0 || area.y < 0 || area.x >= state.columns.length || area.y >= state.rows.length);
  });
};

var gridTemplateAreas = function gridTemplateAreas(state) {
  return state.rows.map(function (row, rIndex) {
    return '    "' + state.columns.map(function (col, cIndex) {
      var areas = state.dragAreas || state.areas;
      var area = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* areaAt */](areas, { x: cIndex, y: rIndex, w: 1, h: 1 });
      return area ? area.label : '.';
    }).join(' ') + '"';
  }).join('\n');
};

var gridStyle = function gridStyle(state) {
  return {
    display: 'grid',
    gridTemplateRows: state.rows.reduce(function (acc, val) {
      return acc + (val.units === 'auto' ? '' : val.size) + val.units + ' ';
    }, ''),
    gridTemplateColumns: state.columns.reduce(function (acc, val) {
      return acc + (val.units === 'auto' ? '' : val.size) + val.units + ' ';
    }, ''),
    gridColumnGap: state.colGap.size && state.colGap.units ? state.colGap.size + state.colGap.units : undefined,
    gridRowGap: state.rowGap.size && state.rowGap.units ? state.rowGap.size + state.rowGap.units : undefined,
    justifyItems: state.justify.value ? state.justify.value : undefined,
    alignItems: state.align.value ? state.align.value : undefined,
    gridTemplateAreas: gridTemplateAreas(state)
  };
};

var itemStyle = function itemStyle(state) {
  return function (item) {
    if (item.id === 'placeholder') {
      return {
        backgroundColor: 'rgba(0,0,0,0.2)',
        border: '3px solid #333',
        position: 'absolute',
        top: 0,
        left: 0,
        height: item.h,
        width: item.w,
        transform: 'translate(' + item.x + 'px,' + item.y + 'px)'
      };
    }
    return {
      border: '3px  solid ' + __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* stringToRGBA */](item.label),
      gridArea: item.label,
      display: item.x < 0 || item.y < 0 || item.x >= state.columns.length || item.y >= state.rows.length ? 'none' : 'block'
    };
  };
};

var css = function css(state) {
  return ('\n@supports (grid-area: auto) {\n  .grid-container{\n    display: grid;\n    grid-template-columns: ' + state.columns.reduce(function (acc, val) {
    return acc + (val.units === 'auto' ? '' : val.size) + val.units + ' ';
  }, '').trim() + ';\n    grid-template-rows: ' + state.rows.reduce(function (acc, val) {
    return acc + (val.units === 'auto' ? '' : val.size) + val.units + ' ';
  }, '').trim() + ';\n    ' + (state.colGap.size && state.colGap.units ? 'grid-column-gap: ' + state.colGap.size + state.colGap.units + ';' : '') + '\n    ' + (state.rowGap.size && state.rowGap.units ? 'grid-row-gap: ' + state.rowGap.size + state.rowGap.units + ';' : '') + '\n    ' + (state.justify.value ? 'justify-items: ' + state.justify.value + ';' : '') + '\n    ' + (state.align.value ? 'align-items: ' + state.align.value + ';' : '') + '\n    grid-template-areas:\n' + gridTemplateAreas(state) + ';\n  }\n    \n' + validAreas(state).sort(function (a, b) {
    return a.label > b.label;
  }).map(function (a) {
    return '  .' + a.label + ' {\n    grid-area: ' + a.label + ';\n  }';
  }).join('\n') + '\n    \n}').replace(/ {4}\n/g, '');
};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutation", function() { return mutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAreas", function() { return setAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDragAreas", function() { return setDragAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addDragArea", function() { return addDragArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addArea", function() { return addArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeArea", function() { return removeArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addRow", function() { return addRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeRow", function() { return removeRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addColumn", function() { return addColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeColumn", function() { return removeColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.


var mutation = function mutation(state, value) {
  state.val = value;
};

var setAreas = function setAreas(state, value) {
  state.areas = value;
};

var setDragAreas = function setDragAreas(state, value) {
  state.dragAreas = value;
};

var addDragArea = function addDragArea(state, value) {
  state.dragAreas.push(value);
};

var addArea = function addArea(state, value) {
  var index = state.areas.length + 1;
  while (state.areas.find(function (a) {
    return a.id === index;
  })) {
    index++;
  }
  while (state.areas.find(function (a) {
    return a.label === 'area' + index;
  })) {
    index++;
  }

  state.areas.push(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* moveToFreePlace */](state.areas, { x: 0, y: 0, w: 1, h: 1, label: 'area' + index, id: index }, state.columns.length - 1, state.rows.length - 1));
};

var removeArea = function removeArea(state, area) {
  if (area) {
    var existingAreaIndex = state.areas.findIndex(function (a) {
      return a.id === area.id;
    });
    console.log(existingAreaIndex);
    if (existingAreaIndex >= 0) {
      state.areas.splice(existingAreaIndex, 1);
    }
  } else {
    state.areas.pop();
  }
};

var addRow = function addRow(state) {
  state.rows.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.rows[state.rows.length - 1]));
  if (state.areas.filter(function (area) {
    return area.x < 0;
  }).length) {
    var newAreas = state.areas.filter(function (area) {
      return area.x >= 0;
    });

    state.areas.filter(function (area) {
      return area.x < 0;
    }).forEach(function (area) {
      newAreas.push(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* moveToFreePlace */](newAreas, area, state.columns.length - 1, state.rows.length - 1));
    });
    state.areas = newAreas;
  }
};

var removeRow = function removeRow(state, row) {
  if (row) {
    var existingRowIndex = state.rows.findIndex(function (r) {
      return r === row;
    });
    if (existingRowIndex >= 0) {
      state.rows.splice(existingRowIndex, 1);
    }
  } else {
    state.rows.pop();
  }
};

var addColumn = function addColumn(state) {
  state.columns.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.columns[state.columns.length - 1]));
  if (state.areas.filter(function (area) {
    return area.x < 0;
  }).length) {
    var newAreas = state.areas.filter(function (area) {
      return area.x >= 0;
    });

    state.areas.filter(function (area) {
      return area.x < 0;
    }).forEach(function (area) {
      newAreas.push(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* moveToFreePlace */](newAreas, area, state.columns.length - 1, state.rows.length - 1));
    });
    state.areas = newAreas;
  }
};

var removeColumn = function removeColumn(state, col) {
  if (col) {
    var existingColIndex = state.columns.findIndex(function (c) {
      return c === col;
    });
    if (existingColIndex >= 0) {
      state.columns.splice(existingColIndex, 1);
    }
  } else {
    state.columns.pop();
  }
};

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_Header___default.a }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about'
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editor',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['areas', 'overflowAreas', 'rows', 'columns', 'css', 'colGap', 'rowGap', 'justify', 'align'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['addArea', 'addRow', 'removeRow', 'addColumn', 'removeColumn']), {
    copyTextToClipboard: function copyTextToClipboard(text) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* copyTextToClipboard */])(text);
    }
  })
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridItem__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GridItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'grid-container',
  components: { GridItem: __WEBPACK_IMPORTED_MODULE_2__GridItem___default.a },
  data: function data() {
    return {
      placeholder: {
        hidden: true,
        x: 0,
        y: 0,
        w: 1,
        h: 1,
        label: 'placeholder',
        id: 'placeholder'
      },
      dragging: {
        item: null,
        offset: {
          x: 0,
          y: 0
        }
      },
      resizing: {
        item: null,
        offset: {
          x: 0,
          y: 0
        }
      },
      initialLayout: undefined
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['gridStyle', 'areas', 'gridSize', 'rows', 'columns', 'dragAreas'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])(['setAreas', 'setDragAreas', 'addDragArea']), {
    dragStart: function dragStart(_ref) {
      var item = _ref.item,
          offset = _ref.offset,
          targetDimensions = _ref.targetDimensions;

      this.dragging.item = item;
      this.placeholder = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* cloneItem */](this.dragging.item);
      this.$set(item, 'dragging', true);
      this.placeholder.label = '';
      this.placeholder.id = 'placeholder';
      this.placeholder.w = targetDimensions.x + 'px';
      this.placeholder.h = targetDimensions.y + 'px';
      this.placeholder.xCorrection = targetDimensions.x / 2;
      this.placeholder.yCorrection = targetDimensions.y / 2;
      this.placeholder.x = offset.x - this.placeholder.xCorrection;
      this.placeholder.y = offset.y - this.placeholder.yCorrection;

      // clone layout
      this.initialLayout = __WEBPACK_IMPORTED_MODULE_1__utils__["e" /* cloneLayout */](this.areas);
    },
    dragUpdate: function dragUpdate(evt) {
      var _this = this;

      if (!this.dragging.item) {
        return;
      }
      this.dragging.offset = evt.offset;

      this.$set(this.placeholder, 'x', evt.offset.x - this.placeholder.xCorrection);
      this.$set(this.placeholder, 'y', evt.offset.y - this.placeholder.yCorrection);

      var draggingArea = document.querySelector('.dragging');
      if (!draggingArea) {
        return;
      }

      this.setDragAreas([]);
      this.addDragArea(this.dragging.item);

      if (this.dragging.offset.x > draggingArea.offsetLeft + draggingArea.offsetWidth) {
        this.$set(this.dragging.item, 'x', this.dragging.item.x + 1);
      }

      if (this.dragging.offset.x < draggingArea.offsetLeft) {
        this.$set(this.dragging.item, 'x', this.dragging.item.x - 1);
      }

      if (this.dragging.item.x < 0) {
        this.dragging.item.x = 0;
      }
      if (this.dragging.item.x >= this.columns.length) {
        this.dragging.item.x = this.columns.length - 1;
      }

      if (this.dragging.offset.y > draggingArea.offsetTop + draggingArea.offsetHeight) {
        this.$set(this.dragging.item, 'y', this.dragging.item.y + 1);
      }

      if (this.dragging.offset.y < draggingArea.offsetTop) {
        this.$set(this.dragging.item, 'y', this.dragging.item.y - 1);
      }

      if (this.dragging.item.y < 0) {
        this.dragging.item.y = 0;
      }
      if (this.dragging.item.y >= this.rows.length) {
        this.dragging.item.y = this.rows.length - 1;
      }

      this.initialLayout.forEach(function (item) {
        if (item.id === _this.dragging.item.id) {
          return;
        }
        _this.addDragArea(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* moveToFreePlace */](_this.dragAreas, item, _this.columns.length - 1, _this.rows.length - 1));
      });
    },
    dragEnd: function dragEnd(evt) {
      if (!this.dragging.item) {
        return;
      }
      if (this.dragAreas) {
        this.setAreas(this.dragAreas);
      }

      this.$delete(this.dragging.item, 'dragging');
      this.dragging.item = null;
      this.dragging.offset.x = 0;
      this.dragging.offset.y = 0;
      this.setDragAreas(null);
    },
    resizeStart: function resizeStart(_ref2) {
      var item = _ref2.item,
          offset = _ref2.offset;

      this.resizing.item = item;
      this.$set(item, 'resizing', true);
      this.resizing.offsetStart = offset;

      this.initialLayout = __WEBPACK_IMPORTED_MODULE_1__utils__["e" /* cloneLayout */](this.areas);
    },
    resizeUpdate: function resizeUpdate(evt) {
      var _this2 = this;

      if (!this.resizing.item) {
        return;
      }
      var previousOffset = this.resizing.offset || { x: 0, y: 0 };
      this.resizing.offset = evt.offset;

      this.setDragAreas([]);
      this.addDragArea(this.resizing.item);

      var changingArea = document.querySelector('.resizing');
      if (!changingArea) {
        return;
      }

      if (previousOffset.x < this.resizing.offset.x && this.resizing.offset.x + this.resizing.offsetStart.x > changingArea.offsetLeft + changingArea.offsetWidth) {
        this.$set(this.resizing.item, 'w', this.resizing.item.w + 1);
      }

      if (previousOffset.x > this.resizing.offset.x && this.resizing.offset.x + this.resizing.offsetStart.x < changingArea.offsetLeft + changingArea.offsetWidth) {
        this.$set(this.resizing.item, 'w', this.resizing.item.w - 1);
      }

      if (this.resizing.item.w < 1) {
        this.resizing.item.w = 1;
      }
      if (this.resizing.item.w + this.resizing.item.x > this.columns.length) {
        this.resizing.item.w = this.columns.length - this.resizing.item.x;
      }

      if (previousOffset.y < this.resizing.offset.y && this.resizing.offset.y + this.resizing.offsetStart.y > changingArea.offsetTop + changingArea.offsetHeight) {
        this.$set(this.resizing.item, 'h', this.resizing.item.h + 1);
      }

      if (previousOffset.y > this.resizing.offset.y && this.resizing.offset.y + this.resizing.offsetStart.y < changingArea.offsetTop + changingArea.offsetHeight) {
        this.$set(this.resizing.item, 'h', this.resizing.item.h - 1);
      }

      if (this.resizing.item.h < 1) {
        this.resizing.item.h = 1;
      }
      if (this.resizing.item.h + this.resizing.item.y > this.rows.length) {
        this.resizing.item.h = this.rows.length - this.resizing.item.y;
      }

      this.initialLayout.forEach(function (item) {
        if (item.id === _this2.resizing.item.id) {
          return;
        }
        _this2.addDragArea(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* moveToFreePlace */](_this2.dragAreas, item, _this2.columns.length - 1, _this2.rows.length - 1));
      });
    },
    resizeEnd: function resizeEnd(evt) {
      if (!this.resizing.item) {
        return;
      }
      if (this.dragAreas) {
        this.setAreas(this.dragAreas);
      }
      this.$delete(this.resizing.item, 'resizing');
      this.resizing.item = null;
      this.resizing.offset.x = 0;
      this.resizing.offset.y = 0;
      this.setDragAreas(null);
    }
  })
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'grid-item',
  props: ['item'],
  data: function data() {
    return {
      renaming: false,
      renamingLabel: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['areas']), {
    style: function style() {
      return this.$store.getters.itemStyle(this.item);
    },
    classes: function classes() {
      return {
        'grid-area': true,
        dragging: this.item.dragging,
        resizing: this.item.resizing
      };
    },

    gridOrigin: function gridOrigin() {
      if (this.$parent.$refs && this.$parent.$refs.gridContainer) {
        return {
          x: this.$parent.$refs.gridContainer.offsetLeft,
          y: this.$parent.$refs.gridContainer.offsetTop
        };
      }
      return { x: 0, y: 0 };
    }
  }),
  directives: {
    focusoninsert: {
      inserted: function inserted(el) {
        el.focus();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['removeArea']), {
    handleRename: function handleRename() {
      var _this = this;

      if (!this.renaming || !this.renamingLabel || this.areas.find(function (a) {
        return a.label === _this.renamingLabel;
      })) {
        this.renamingLabel = '';
        this.renaming = false;
        return;
      }
      this.item.label = this.renamingLabel.replace(/ /g, '-');
      this.renamingLabel = '';
      this.renaming = false;
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.$refs.label.addEventListener('mousedown', function (evt) {
      if (evt.button !== 0) {
        return;
      }
      _this2.renaming = true;
      _this2.renamingLabel = _this2.item.label;
      evt.preventDefault();
      evt.stopPropagation();
    });
    this.$el.addEventListener('mousedown', function (evt) {
      if (evt.button !== 0 || evt.target.localName === 'input' || evt.target.localName === 'span') {
        return;
      }
      evt.preventDefault();
      var offset = {
        x: evt.pageX - _this2.gridOrigin.x,
        y: evt.pageY - _this2.gridOrigin.y
      };
      var targetDimensions = {
        x: evt.target.clientWidth,
        y: evt.target.clientHeight
      };
      _this2.$emit('dragStart', { item: _this2.item, offset: offset, targetDimensions: targetDimensions });
      var mouseX = evt.clientX;
      var mouseY = evt.clientY;

      var handleMouseUp = function handleMouseUp(evt) {
        window.removeEventListener('mouseup', handleMouseUp, true);
        window.removeEventListener('mousemove', handleMouseMove, true);

        var offset = {
          x: evt.clientX - mouseX,
          y: evt.clientY - mouseY
        };
        _this2.$emit('dragEnd', { offset: offset });
      };

      var handleMouseMove = function handleMouseMove(evt) {
        var offset = {
          x: evt.pageX - _this2.gridOrigin.x,
          y: evt.pageY - _this2.gridOrigin.y
        };
        _this2.$emit('dragUpdate', { offset: offset });
      };

      window.addEventListener('mouseup', handleMouseUp, true);
      window.addEventListener('mousemove', handleMouseMove, true);
    });

    this.$resizeHandle = this.$refs.resizeHandle;
    if (this.$resizeHandle) {
      this.$resizeHandle.addEventListener('mousedown', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var offset = {
          x: evt.pageX - _this2.gridOrigin.x,
          y: evt.pageY - _this2.gridOrigin.y
        };
        _this2.$emit('resizeStart', { item: _this2.item, offset: offset });
        var mouseX = evt.clientX;
        var mouseY = evt.clientY;

        var handleMouseUp = function handleMouseUp(evt) {
          window.removeEventListener('mouseup', handleMouseUp, true);
          window.removeEventListener('mousemove', handleMouseMove, true);

          var offset = {
            x: evt.clientX - mouseX,
            y: evt.clientY - mouseY
          };
          _this2.$emit('resizeEnd', { offset: offset });
        };

        var handleMouseMove = function handleMouseMove(evt) {
          var offset = {
            x: evt.clientX - mouseX,
            y: evt.clientY - mouseY
          };
          _this2.$emit('resizeUpdate', { offset: offset });
        };

        window.addEventListener('mouseup', handleMouseUp, true);
        window.addEventListener('mousemove', handleMouseMove, true);
      });
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-header'
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Editor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GridContainer__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GridContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GridContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridItem__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GridItem__);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  components: { Editor: __WEBPACK_IMPORTED_MODULE_0__components_Editor___default.a, GridContainer: __WEBPACK_IMPORTED_MODULE_1__GridContainer___default.a, GridItem: __WEBPACK_IMPORTED_MODULE_2__GridItem___default.a }
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(62)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(75),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(58)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(71),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(74),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(70),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(72),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(77),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('router-link', {
    staticClass: "header__a",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Grid-Awesome")]), _vm._v(" "), _c('router-link', {
    staticClass: "header__a right",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1)
},staticRenderFns: []}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Grid Template Areas: " + _vm._s(_vm.areas.length))]), _vm._v(" "), _c('button', {
    staticClass: "input__button input__button--add",
    on: {
      "click": _vm.addArea
    }
  }, [_vm._v("Add an area")]), _vm._v(" "), (_vm.overflowAreas.length) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.overflowAreas.length) + " area" + _vm._s(_vm.overflowAreas.length === 1 ? '' : 's') + " cannot fit in grid. Add a " + _vm._s(_vm.overflowAreas.filter(function (area) { return area.x < 0; }).length ? 'row or column' : _vm.overflowAreas.filter(function (area) { return area.x > _vm.columns.length - 1; }).length ? 'column' : 'row') + ".")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Grid Template Columns: " + _vm._s(_vm.columns.length))]), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return _c('div', [_vm._v("\n          Column " + _vm._s(index + 1) + " \n          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (column.size),
        expression: "column.size"
      }],
      staticClass: "input__input--size",
      attrs: {
        "type": "number",
        "name": "size",
        "size": "5",
        "disabled": column.units === 'auto'
      },
      domProps: {
        "value": (column.size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          column.size = $event.target.value
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (column.units),
        expression: "column.units"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          column.units = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "val": "auto"
      }
    }, [_vm._v("auto")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "%"
      }
    }, [_vm._v("%")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "em"
      }
    }, [_vm._v("em")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "rem"
      }
    }, [_vm._v("rem")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "fr"
      }
    }, [_vm._v("fr")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "px"
      }
    }, [_vm._v("px")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "vw"
      }
    }, [_vm._v("vw")])]), _vm._v(" "), (_vm.columns.length > 1) ? _c('button', {
      staticClass: "input__button input__button--remove",
      on: {
        "click": function($event) {
          _vm.removeColumn(column)
        }
      }
    }, [_vm._v("X")]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    staticClass: "input__button input__button--add",
    on: {
      "click": _vm.addColumn
    }
  }, [_vm._v("Add Column")]), _vm._v("Remove Column")], 2), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Grid Template Rows: " + _vm._s(_vm.rows.length))]), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
    return _c('div', [_vm._v("\n          Row " + _vm._s(index + 1) + " \n          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.size),
        expression: "row.size"
      }],
      staticClass: "input__input--size",
      attrs: {
        "type": "number",
        "name": "size",
        "size": "5",
        "disabled": row.units === 'auto'
      },
      domProps: {
        "value": (row.size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          row.size = $event.target.value
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.units),
        expression: "row.units"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          row.units = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "val": "auto"
      }
    }, [_vm._v("auto")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "%"
      }
    }, [_vm._v("%")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "em"
      }
    }, [_vm._v("em")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "rem"
      }
    }, [_vm._v("rem")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "fr"
      }
    }, [_vm._v("fr")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "px"
      }
    }, [_vm._v("px")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "vh"
      }
    }, [_vm._v("vh")])]), _vm._v(" "), (_vm.rows.length > 1) ? _c('button', {
      staticClass: "input__button input__button--remove",
      on: {
        "click": function($event) {
          _vm.removeRow(row)
        }
      }
    }, [_vm._v("X")]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    staticClass: "input__button input__button--add",
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("Add Row")])], 2), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Grid Column Gap")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colGap.size),
      expression: "colGap.size"
    }],
    staticClass: "input__input--size",
    attrs: {
      "type": "number",
      "name": "size",
      "size": "5"
    },
    domProps: {
      "value": (_vm.colGap.size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.colGap.size = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colGap.units),
      expression: "colGap.units"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.colGap.units = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "val": "%"
    }
  }, [_vm._v("%")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "em"
    }
  }, [_vm._v("em")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "rem"
    }
  }, [_vm._v("rem")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "px"
    }
  }, [_vm._v("px")])])]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Grid Row Gap")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rowGap.size),
      expression: "rowGap.size"
    }],
    staticClass: "input__input--size",
    attrs: {
      "type": "number",
      "name": "size",
      "size": "5"
    },
    domProps: {
      "value": (_vm.rowGap.size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rowGap.size = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rowGap.units),
      expression: "rowGap.units"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rowGap.units = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "val": "%"
    }
  }, [_vm._v("%")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "em"
    }
  }, [_vm._v("em")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "rem"
    }
  }, [_vm._v("rem")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "px"
    }
  }, [_vm._v("px")])])]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Justify Items")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justify.value),
      expression: "justify.value"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.justify.value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "val": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "val": "stretch"
    }
  }, [_vm._v("stretch")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "center"
    }
  }, [_vm._v("center")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "start"
    }
  }, [_vm._v("start")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "end"
    }
  }, [_vm._v("end")])])]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Align Items")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.align.value),
      expression: "align.value"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.align.value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "val": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "val": "stretch"
    }
  }, [_vm._v("stretch")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "center"
    }
  }, [_vm._v("center")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "start"
    }
  }, [_vm._v("start")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "end"
    }
  }, [_vm._v("end")])])])]), _vm._v(" "), _c('div', {
    staticClass: "css-output"
  }, [_c('button', {
    staticClass: "input__button button--clipboard",
    on: {
      "click": function($event) {
        _vm.copyTextToClipboard(_vm.css)
      }
    }
  }, [_vm._v("Copy to Clipboard")]), _vm._v("\n      CSS: \n      " + _vm._s(_vm.css) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello content"
  }, [_c('editor'), _vm._v(" "), _c('grid-container')], 1)
},staticRenderFns: []}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    style: (_vm.style)
  }, [(_vm.renaming) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.renamingLabel),
      expression: "renamingLabel"
    }, {
      name: "focusoninsert",
      rawName: "v-focusoninsert"
    }],
    staticClass: "input--rename",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.renamingLabel)
    },
    on: {
      "blur": _vm.handleRename,
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleRename($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.renamingLabel = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    ref: "label",
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.item.label))]), _vm._v(" "), _c('span', {
    staticClass: "remove-button",
    on: {
      "click": function($event) {
        _vm.removeArea(_vm.item)
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('div', {
    ref: "resizeHandle",
    staticClass: "resize-handle"
  }, [_c('img', {
    staticClass: "img--resize_handle",
    attrs: {
      "src": "static/img/resize.svg"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gridContainer",
    staticClass: "grid-container",
    style: (_vm.gridStyle)
  }, [(this.dragAreas) ? _vm._l((_vm.dragAreas), function(item, index) {
    return _c('grid-item', {
      key: item.label,
      attrs: {
        "item": item
      }
    })
  }) : _vm._l((_vm.areas), function(item, index) {
    return _c('grid-item', {
      key: item.label,
      attrs: {
        "item": item
      },
      on: {
        "dragStart": _vm.dragStart,
        "dragUpdate": _vm.dragUpdate,
        "dragEnd": _vm.dragEnd,
        "resizeStart": _vm.resizeStart,
        "resizeUpdate": _vm.resizeUpdate,
        "resizeEnd": _vm.resizeEnd
      }
    })
  }), _vm._v(" "), (_vm.dragging.item) ? _c('grid-item', {
    key: 'placeholder',
    attrs: {
      "item": _vm.placeholder
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "about-content padded"
  }, [_c('h3', {
    staticClass: "center"
  }, [_vm._v("About Grid Awesome")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("Quickly and easily create css "), _c('span', {
    staticStyle: {
      "color": "#428E9C"
    }
  }, [_vm._v("display"), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(":")]), _vm._v(" grid")]), _vm._v("; boilerplate.")])]), _vm._v(" "), _c('p', [_vm._v("Use Grid-Awesome to generate boilerplate css for grid layouts using the css "), _c('a', {
    attrs: {
      "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Grid_Layout"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#428E9C"
    }
  }, [_vm._v("display"), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(":")]), _vm._v(" grid")]), _vm._v(";")]), _vm._v(" property.")]), _vm._v(" "), _c('p', [_vm._v("Combined with media queries, completely customize the site layout with just a few lines of CSS (hide area 3 and change display order on mobile):")]), _vm._v(" "), _c('pre', [_vm._v("@supports (grid-area: auto) \n  /* mobile first */\n  .grid-container{\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto auto;\n    grid-template-areas:\n    \"area2\"\n    \"area1\"\n    \"area4\";\n  }\n  .area1 {\n    grid-area: area1;\n  }\n  .area2 {\n    grid-area: area2;\n  }\n  .area3 {\n    grid-area: area3;\n  }\n  .area4 {\n    grid-area: area4;\n  }\n\n  /* desktop */\n  @media screen and (min-width: 768px) {\n    .grid-container{\n      display: grid;\n      grid-template-columns: 3fr 4fr;\n      grid-template-rows: 10rem 15rem 20rem;\n      grid-template-areas:\n      \"area1 area1\"\n      \"area2 area3\"\n      \"area4 area4\";\n    }\n  }\n}")]), _vm._v("\nHTML:\n"), _c('pre', [_vm._v("<div class=\"grid-container\">\n  <div class=\"area1\"></div>\n  <div class=\"area2\"></div>\n  <div class=\"area3\"></div>\n  <div class=\"area4\"></div>\n</div>\n\n")])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "https://github.com/louisbourque/grid-awesome"
    }
  }, [_vm._v("View in GitHub")])]), _vm._v(" "), _c('div', {
    staticClass: "div--margintop"
  }, [_vm._v("Powered by "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/vue-logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "div--margintop"
  }, [_vm._v("Built by "), _c('a', {
    attrs: {
      "href": "http://louisbourque.ca/"
    }
  }, [_vm._v("Louis Bourque")]), _vm._v(".")])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site",
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "404 center"
  }, [_c('p', [_vm._v("Page not found")])])
}]}

/***/ })
],[19]);


// WEBPACK FOOTER //
// static/js/app.b05b3153693df5d3eefb.js